import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

import {LoaderState} from '../types';

/**
 * A service to provide and change a state info about if current XHR requests are running or not
 *
 * It is used as a state store to be used as a injectable in components and other services.
 */
@Injectable()
export class LoaderService {
  private loaderSubject = new Subject<LoaderState>();

  loaderState = this.loaderSubject.asObservable();

  constructor() { }

  show() {
    this.loaderSubject.next({show: true} as LoaderState);
  }

  hide() {
    this.loaderSubject.next({show: false} as LoaderState);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/loader-service/services/loader.service.ts